export const templateEditorWidgetStrings = {
  newTitle: 'Nueva plantilla',
  save: 'Guardar plantilla',
  saving: 'Guardando...',
  cancel: 'Cancelar',
  saved: 'Plantilla guardada.',
  unsaved: 'Cambios sin guardar',
  fieldName: 'Nombre de la plantilla',
  fieldNamePlaceholder: 'Ej. Intervención de emergencia',
  fieldCategory: 'Categoría',
  fieldCategoryPlaceholder: 'Selecciona una categoría',
  statusNew: 'Nueva',
  statusEdited: 'Editada',
  statusLocked: 'Bloqueada',
  lockedBanner:
    'Esta plantilla está bloqueada por uno o más tipos. Elimínalos primero para editarla.',
  lockedTypesPrefix: 'Bloqueada por:',
  addSection: '+ Sección',
  addText: '+ Texto',
  addChecklist: '+ Checklist',
  addSteps: '+ Pasos',
  addDecision: '+ Decisión',
  addDosage: '+ Tabla dosis',
  addAlert: '+ Alerta',
  addVitals: '+ Signos vitales',
  addClinicalNotes: '+ Nota clínica',
  addImagingOrder: '+ Orden de imagen',
  addLabOrder: '+ Orden de laboratorio',
  needsSection: 'Añade primero una sección para contener este bloque.',
  requiredLabel: 'Requerido',
  requiredSectionLabel: 'Requerida',
  deleteSectionConfirm: (title: string, count: number) =>
    `¿Eliminar la sección "${title}" y sus ${count} bloque${count === 1 ? '' : 's'} hijo${count === 1 ? '' : 's'}?`,
  placeholderHint: 'Pista para el médico (opcional)',
  sectionTitleLabel: 'Título de la sección',
  sectionTitlePlaceholder: 'Ej. Indicaciones',
  sectionDescLabel: 'Descripción (opcional)',
  navigateAway: 'Tienes cambios sin guardar. ¿Descartar y salir?',
  moveUp: 'Mover arriba',
  moveDown: 'Mover abajo',
  duplicate: 'Duplicar',
  delete: 'Eliminar',
  requiredTooltip: 'Desactiva "Requerido" antes de eliminar.',
  noTitle: '(sin título)',
  blockTitleOptional: 'Título (opcional)',
  blockDescriptionPlaceholder: 'Descripción corta (opcional)',
  blockPlaceholderInstruction: 'Instrucción para el médico al rellenar este bloque',
  addBlockLabel: 'Añadir bloque',
  clinicalNotesLabelPlaceholder: 'Ej. Nota de evolución',
  dosageRowsLabel: 'Filas de dosis',
  dosageColumnLabels: {
    drug: 'Fármaco',
    dose: 'Dosis',
    route: 'Vía',
    frequency: 'Frecuencia',
    notes: 'Notas',
  },
  dosageAddRow: '+ Añadir fila',
  dosageRemoveRow: 'Eliminar fila',
} as const
